import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import { ElementType, NumberFormat, SelectCombos, CommonResponses, } from '../Enums/constants';


export const PabsUkActivesTab = () => {
    return (
        <SurveyPage pageName='Actives'>
            <SurveyTitleArea labelText='' />
            <SurveyContentContainer>
                <SurveySection labelText='Pension Set Ups'>
                    <SurveyElement
                        questionNumber='12'
                        labelText="What % of pension set-ups were paid without an interruption of the individual's income of greater than 1 month between the final pay as an employee and the first pension instalment?"
                        name='Q_110'
                        allowUnknown
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE_UK}
                        placeholder='%, unknown'
                        pageName='Actives'
                    />
                    <SurveyElement
                        questionNumber='13'
                        labelText="What % of tax free lump sum payments were paid within 1 week of the individual's retirement date?"
                        name='UKPctTaxFreeLumpSum'
                        allowUnknown
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE_UK}
                        placeholder='%, unknown'
                        pageName='Actives'
                    />
                    <SurveyElement
                        questionNumber='14'
                        labelText="Do the rules of your scheme mean that you cannot accurately calculate the pension for a retiring active member until after the last payroll run as an employee (i.e., the calculation relies upon data from the last payroll - ignore AVCs for this purpose)?"
                        name='PensionReliesLastPayrollYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        pageName='Actives'
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            PensionReliesLastPayrollYN: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            questionNumber='14.a'
                            labelText="If yes, will you set up a pension based on estimated data, knowing that you will have to go back and correct the pension later?"
                            name='PensionReliesLastPayrollEstimateYN'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                    </SurveyConditionalSegment>
                    <SurveyElement
                        questionNumber='14.b'
                        labelText="How many employers do you collect membership data from (an approximation is fine)?"
                        name='PensionDataCollectionEmployerVol'
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='14.c'
                        labelText="What is your SLA for setting up new pensions, e.g., by the ext payroll cut-off? (This question is being asked as a one-off to help us to refine our survey in future years)."
                        inputType={ElementType.TEXTAREA}
                        name='PensionSLADesc'
                        placeholder=''
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='14.d'
                        labelText="What is your normal payroll cut-off date in the month?"
                        inputType={ElementType.TEXTAREA}
                        name='PayrollCutOffDesc'
                        placeholder=''
                        subQuestion
                    />
                </SurveySection>


                <SurveySection labelText='One-to-One Meetings & Conversations'>
                    <SurveyElement
                        questionNumber='15'
                        labelText='Do you meet face-to-face with active members?'
                        name='DoYouDo1On1'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        pageName='Actives'
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            labelText='Provide the number of active members that you met one-to-one:'
                            pageName='Actives'
                        />
                        <SurveyElement
                            questionNumber='15.a'
                            labelText="At the administrator's office?"
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            name='InHouse1On1'
                            placeholder='#, unknown'
                            subQuestion
                            allowUnknown
                        />
                        <SurveyElement
                            questionNumber='15.b'
                            labelText="In-the-field (not at the administrator's office)"
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            name='UKMQ_114d'
                            allowUnknown
                            placeholder='#, unknown'
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='15.c'
                            labelText='Over the internet (e.g. Teams or Zoom)'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            name='Web1on1Vol'
                            allowUnknown
                            placeholder='#, unknown'
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='16'
                            labelText='How many scheduled, outbound telephone calls did you make (i.e., a pre-scheduled session on a matter of substance that might cover material sent to the member in advance of the session, e.g., a quotation or estimate)?'
                            name='Q_114e'
                            inputType={ElementType.NUMBER}
                            allowUnknown
                            format={NumberFormat.INTEGER}
                            pageName='Actives'
                            placeholder='#, unknown'
                        />
                    </SurveyConditionalSegment>
                </SurveySection>

                <SurveySection labelText='Group Meetings'>
                    <SurveyElement
                        questionNumber='17'
                        labelText='Do you meet with active members in groups (i.e., member presentations)?'
                        name='q_126'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        pageName='Actives'
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            q_126: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            questionNumber='17.a'
                            labelText='Provide the number of presentations you delivered in person.'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#, unknown'
                            name='PresentationsInPerson'
                            allowUnknown
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='17.b'
                            labelText='Provide the number of presentations you delivered via live webinar (i.e., real-time, online presentations that allows two-way communication between the presenter and audience).'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#, unknown'
                            subQuestion
                            name='presentationswebcast'
                            allowUnknown
                        />
                        <SurveyElement
                            questionNumber='17.c'
                            labelText='# of members that you met in groups, in-person? (A)'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#, unknown'
                            subQuestion
                            name='PresentationAttendeesTotal'
                            allowUnknown
                        />
                        <SurveyElement
                            questionNumber='17.d'
                            labelText='# of members that you met in groups, via webinar? (B)'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#, unknown'
                            subQuestion
                            name='WebinarsAttendees'
                            allowUnknown
                        />
                        <SurveyElement
                            questionNumber='17.e'
                            labelText='Total # of members that you met in groups? (A+B)'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#, unknown'
                            subQuestion
                            name='TotalPresentationAttendees'
                            allowUnknown
                        />
                    </SurveyConditionalSegment>
                </SurveySection>

                <SurveySection labelText='Elapsed Times - Death-In-Service'>
                    <SurveyElement
                        labelText={`We are asking for details of elapsed times, which reflect the members actual service experience, measured from the point you were first notified to the point of fulfilment. If you don't measure elapsed times then please feel free to estimate, i.e., a typical death-in-service process might take 3 months from the point of notification (accepting there might be a wide range)`}
                        inputType={ElementType.LABEL}
                        name=''
                    />
                    <SurveyElement
                        questionNumber='18'
                        labelText='What is the average elapsed time (in weeks) from the point of initial notification to the point of paying the first instalment of any dependent’s pension and/or paying the lump sum, whichever is later (in weeks, including delays caused by third-parties)?'
                        name='UKActiveDeathInServiceElapsedTimes'
                        allowUnknown
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder='# weeks, unknown'
                        pageName='Actives'
                    />
                    <SurveyElement
                        questionNumber='18.a'
                        labelText='Is this measured or estimated?'
                        name='UKActiveDeathInServiceElapsedTimesMeasured'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.MEASURED_ESTIMATED}
                        pageName='Actives'
                        subQuestion
                    />
                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    )
}